import React from 'react';
import { Image, Platform, View } from 'react-native';
import Icon from 'react-native-vector-icons/dist/Feather';
import { useTheme } from 'styled-components/native';

import { DeepLinkFirstAccessStepProps } from '../types';
import BandaidDesktop from '~/assets/images/bandaid-tem-desktop.png';
import BandaidMobile from '~/assets/images/bandaid-tem-mobile.png';

import * as S from '~/screens/Login/components/Welcome/styles';

import { Button, Typography } from '~/components/@hello-ui';

export const DeepLinkFirstAccessWelcome = ({ setStep }: DeepLinkFirstAccessStepProps) => {
  const theme = useTheme();

  return (
    <>
      <View
        style={Platform.select({
          web: {
            width: '100%',
            alignItems: 'center',
            height: '100dvh',
          },
          default: {
            width: '100%',
            flex: 1,
            alignItems: 'center',
          },
        })}>
        <S.WrapperIcon>
          <Image
            style={{
              width: '100%',
              height: '100%',
            }}
            source={Platform.OS === 'web' ? BandaidDesktop : BandaidMobile}
            resizeMode="contain"
          />
        </S.WrapperIcon>
        <S.Wrapper
          style={{
            minWidth: 328,
            maxWidth: 370,
          }}>
          <S.WrapperTexts
            style={{
              marginBottom: 12,
              width: '100%',
            }}>
            <Typography variant="title">Estamos felizes em ter você aqui!</Typography>
            <Typography className="mt-12 w-[328px]" variant="body1" style={{ textAlign: 'center' }}>
              Para que nós possamos oferecer a melhor experiência, precisamos de mais algumas
              informações.
            </Typography>
          </S.WrapperTexts>
          <S.WrapperButton>
            <Button
              variant="link"
              icon={<Icon name="chevron-right" size={24} color={theme.colors.primary} />}
              iconPosition="right"
              onPress={() => setStep('gender')}>
              Complete seu cadastro
            </Button>
          </S.WrapperButton>
        </S.Wrapper>
        <S.WrapperFooter>
          <Typography variant="helperText" color="black20">
            Powered by TEM Saúde
          </Typography>
        </S.WrapperFooter>
      </View>
    </>
  );
};
